import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  actionButtons: {
    display: 'flex',
  },
  editButton: {
    paddingRight: '40px',
  },
  deleteButton: {},
  scopeCell: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  scopeTag: {
    padding: '2px 8px',
    borderRadius: 12,
    border: `1px solid ${theme.palette.grey[500]}`,
    fontSize: '0.75rem',
  },
}));

export default useStyles;
